module.exports = __webpack_public_path__ + "img/cross.9d116f2e.svg";